/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import {
  DocumentsGroup,
  DocumentsState,
  DocumentsTypes,
} from 'store/modules/documents_store/types';
import { getDocumentsFilter } from 'store/modules/documents_store/actions';
import tabId from 'services/tabId';
import { PanelState } from 'store/modules/panel_store/types';
import { Container } from './styles';

interface DocumentsSearchFormFormProps {
  searchBarOpened: boolean;
  setSearchBarOpened: React.Dispatch<React.SetStateAction<boolean>>;
  hideUnavailableDocuments: boolean;
  setHideUnavailableDocuments: React.Dispatch<React.SetStateAction<boolean>>;
  documentGroupList: Array<DocumentsGroup>;
}

const DocumentsSearchForm = (props: DocumentsSearchFormFormProps) => {
  const dispatch = useDispatch();
  const {
    setSearchBarOpened,
    searchBarOpened,
    hideUnavailableDocuments,
    setHideUnavailableDocuments,
    documentGroupList,
  } = props;
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { documents_list, documents, request } = useSelector<ApplicationState, DocumentsState>(
    (state) => state.session.documents,
  );
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const [monitoredCompaniesOptions, setMonitoredCompaniesOptions] = useState<Array<any>>([]);
  const [documentGroups, setDocumentGroups] = useState<Array<number>>([]);
  const [documentStatus, setDocumentStatus] = useState<Array<number>>([]);
  const [documentUpdateTypes, setDocumentUpdateTypes] = useState<Array<number>>([]);
  const [nameDescription, setNameDescription] = useState<string>('');

  const DocumentStatusOptions = ['Disponível', 'Pendente', 'Coletando'];
  const documentUpdateTypesOptions = ['Manual', 'Automático'];

  const handleClick = () => {
    const cnpj = documents_list?.current_cnpj || profile?.cnpj;
    const companyId = profile?.representant
      ? documents_list?.monitored_companies.find((d) => d.monitored_company === cnpj)?.client_id
      : null;

    const params = {
      cnpj,
      documentGroups,
      documentStatus,
      documentUpdateTypes,
      nameDescription,
      companyId,
    };
    dispatch(getDocumentsFilter(params));
  };

  const handleClear = async () => {
    setDocumentGroups([]);
    setDocumentStatus([]);
    setDocumentUpdateTypes([]);
    setNameDescription('');
    setHideUnavailableDocuments(false);
  };

  useEffect(() => {
    dispatch({
      type: DocumentsTypes.CURRENT_COMPANY,
      company: monitoredCompaniesOptions[0],
      currentCompany: monitoredCompaniesOptions[0]?.value,
    });

    setMonitoredCompaniesOptions(
      documents_list?.monitored_companies.map((companie) => {
        return {
          value: companie?.monitored_company,
          label: (
            <>
              {companie.company_name}
              <br />
              <small>
                {companie.monitored_company.replace(
                  /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                  '$1.$2.$3/$4-$5',
                )}
              </small>
            </>
          ),
          companyName: companie.company_name,
        };
      }),
    );
  }, [documents_list?.monitored_companies]);

  useEffect(() => {
    dispatch({
      type: DocumentsTypes.CURRENT_COMPANY,
      company:
        monitoredCompaniesOptions?.length > 0
          ? monitoredCompaniesOptions?.find(
              (company) => company.id === profile.currentCompany[tabId()],
            )
          : monitoredCompaniesOptions[0],
      currentCompany:
        monitoredCompaniesOptions?.length > 0
          ? monitoredCompaniesOptions?.find(
              (company) => company.id === profile.currentCompany[tabId()],
            )?.cnpj
          : monitoredCompaniesOptions[0]?.value,
    });
  }, [profile.currentCompany[tabId()]]);

  useEffect(() => {
    if (hideUnavailableDocuments) {
      const docs = documents.filter((document) => {
        return !document.statusLabel.includes('Indisponível');
      });
      dispatch({ type: DocumentsTypes.LIST_DOCUMENT, docs });
    }
  }, [hideUnavailableDocuments]);

  useEffect(() => {
    dispatch({
      type: DocumentsTypes.CURRENT_COMPANY,
      company: monitoredCompaniesOptions[0],
      currentCompany: monitoredCompaniesOptions[0]?.value,
    });
  }, [monitoredCompaniesOptions]);

  const selectedIndex = monitoredCompaniesOptions.findIndex(
    (option) => option.value === documents_list?.current_cnpj,
  );

  const selectedValue =
    selectedIndex !== -1 ? monitoredCompaniesOptions[selectedIndex] : monitoredCompaniesOptions[0];

  const handleGroupChange = (groupValue: number, isChecked: boolean) => {
    setDocumentGroups((prevGroups) =>
      isChecked ? [...prevGroups, groupValue] : prevGroups.filter((value) => value !== groupValue),
    );
  };

  const handleStatusChange = (statusValue: number, isChecked: boolean) => {
    setDocumentStatus((prevStatus) =>
      isChecked
        ? [...prevStatus, statusValue]
        : prevStatus.filter((value) => value !== statusValue),
    );
  };

  const handleUpdateTypeChange = (updateTypeValue: number, isChecked: boolean) => {
    setDocumentUpdateTypes((prevTypes) =>
      isChecked
        ? [...prevTypes, updateTypeValue]
        : prevTypes.filter((value) => value !== updateTypeValue),
    );
  };

  return (
    <Container>
      <div className="row">
        <div
          className={`col-11 mx-auto col-lg-3 col-md-12 pr-2 filter-bar shadow ${
            searchBarOpened ? '' : 'hide-bar'
          } ${
            profile.in_sample || panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
          }`}
        >
          <button
            type="button"
            onClick={() => setSearchBarOpened(!searchBarOpened)}
            className="btn btn-sm btn-link position-absolute btn-hide-search d-xxl-none"
          >
            <i className="material-icons p-1">search</i>
          </button>
          <div className="filter-form pr-2">
            <div className="row d-print-none">
              <div className="col-md-12">
                <div className="row mb-3">
                  <div className="col-md-12 pr-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-link float-right"
                      onClick={handleClear}
                    >
                      Limpar
                    </button>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="company">
                      <h6 className="font-weight-bold">Documentos da Empresa:</h6>
                    </label>
                    {documents_list?.monitored_companies.length > 1 ? (
                      <Select
                        isLoading={request.filter_documents.loading}
                        isSearchable={false}
                        loadingMessage={() => 'Carregando empresas'}
                        name="monitoredCompanies"
                        value={request.filter_documents.loading ? [] : selectedValue}
                        placeholder={
                          request.filter_documents.loaded
                            ? 'Escolha uma empresa'
                            : 'Carregando empresas'
                        }
                        closeMenuOnSelect
                        onChange={(event: any) =>
                          dispatch({
                            type: DocumentsTypes.CURRENT_COMPANY,
                            company: event,
                            currentCompany: event?.value,
                          })
                        }
                        options={request.filter_documents.loading ? [] : monitoredCompaniesOptions}
                        className="basic-multi-select"
                      />
                    ) : (
                      <>
                        <h5 className="mt-2 mb-0">
                          {documents_list?.monitored_companies[0]?.company_name}
                        </h5>
                        <small>
                          {documents_list?.monitored_companies[0]?.monitored_company.replace(
                            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                            '$1.$2.$3/$4-$5',
                          )}
                        </small>
                      </>
                    )}
                  </div>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={hideUnavailableDocuments}
                    id="exact_search"
                    onChange={(e) => setHideUnavailableDocuments(e.target.checked)}
                  />
                  <label className="form-check-label mt-1" htmlFor="exact_search">
                    Ocultar documentos indisponíveis
                  </label>
                </div>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <label htmlFor="stateSearch" className="m-0">
                      <h6 className="font-weight-bold">Busca</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="company"
                      value={nameDescription}
                      onChange={(e) => setNameDescription(e.target.value)}
                    />
                  </div>
                </div>
                <hr />
                <h6 className="font-weight-bold">Grupos de Documentos</h6>
                <div className="checkList">
                  <div className="list-container">
                    {documentGroupList?.map((item: any, index) => (
                      <div key={index}>
                        <input
                          type="checkbox"
                          className="mr-2"
                          id={item.label}
                          checked={documentGroups.includes(item.value)}
                          onChange={(e) => handleGroupChange(item.value, e.target.checked)}
                        />
                        <span>{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <hr />
                <h6 className="font-weight-bold">Situação do Documento</h6>
                <div className="list-container">
                  {DocumentStatusOptions.map((item, index) => (
                    <div key={index}>
                      <input
                        value={index + 1}
                        type="checkbox"
                        className="mr-2"
                        id={item}
                        checked={documentStatus.includes(index + 1)}
                        onChange={(e) => handleStatusChange(index + 1, e.target.checked)}
                      />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
                <hr />
                <h6 className="font-weight-bold">Forma de Atualização</h6>
                <div className="list-container">
                  {documentUpdateTypesOptions.map((item, index) => (
                    <div key={index}>
                      <input
                        value={index}
                        type="checkbox"
                        className="mr-2"
                        checked={documentUpdateTypes.includes(index)}
                        onChange={(e) => handleUpdateTypeChange(index, e.target.checked)}
                      />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
                <div className="col-12 col-md-3 px-2 py-3 filter-button d-print-none">
                  <button type="button" className="btn btn-primary w-100" onClick={handleClick}>
                    Filtrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default DocumentsSearchForm;
